import {MultiSelectionBox} from 'notebook/tables/TableConstants';

/**
 * Computes whether fill-down is enabled for the table as a feature.
 * Fill-down is enabled when `enableFillDown` is explicitly true,
 * or when formulas are not disabled (fill-down is a formula-adjacent feature).
 *
 * @param enableFillDown - The explicit enableFillDown prop value
 * @param disableFormulas - Whether formulas are disabled for this table
 */
export function computeIsFillDownEnabled(
  enableFillDown: boolean | undefined,
  disableFormulas: boolean
): boolean {
  return enableFillDown === true || !disableFormulas;
}

/**
 * Computes whether fill-down is currently active (user is dragging the fill handle).
 * Reads from the multiExtra state and defaults to false when not set.
 *
 * @param fillDownActive - The fillDownActive state value from multiExtra
 */
export function computeIsFillDownActive(fillDownActive: boolean | undefined): boolean {
  return fillDownActive ?? false;
}

/**
 * Computes whether the current fill-down operation is invalid (e.g. dragging
 * over merged regions). Reads from the multiExtra state and defaults to false.
 *
 * @param fillDownInvalid - The fillDownInvalid state value from multiExtra
 */
export function computeIsFillDownInvalid(fillDownInvalid: boolean | undefined): boolean {
  return fillDownInvalid ?? false;
}

/**
 * Extracts the fill-down box from the multiExtra state.
 * The fill-down box represents the range of cells being filled.
 *
 * @param fillDownBox - The fillDownBox state value from multiExtra
 */
export function computeFillDownBox(
  fillDownBox: MultiSelectionBox | null | undefined
): MultiSelectionBox | null | undefined {
  return fillDownBox;
}
